import { Avatar, Image, Space, Tag, Tooltip, Typography } from 'antd'
import { AvatarProps } from 'antd/es/avatar'
import { Link } from 'react-router-dom'
import { Contact as ContactModel } from '../../models/Contact'
import { useAppSelector } from '../../store/hooks'
import { selectContactById } from '../../store/ContactReducer'
import { UserOutlined } from '@ant-design/icons'

const { Text } = Typography

interface Props {
  id?: number
  model?: ContactModel
  size?: AvatarProps['size']
  type?: 'full' | 'condensed'
}

export const ContactAvatar = ({
  id,
  model,
  size = 'default',
  type = 'full',
}: Props) => {
  const contact = model ? model : useAppSelector(selectContactById(id!))

  if (!contact) {
    return <></>
  }

  return (
    <Link
      to={`https://instagram.com/${contact.instagramUsername}`}
      target="_blank"
    >
      <Space direction="horizontal">
        <Tooltip
          title={`${contact.instagramName}`}
          open={type == 'full' ? false : undefined}
        >
          <Avatar
            icon={<UserOutlined />}
            size={size == 'large' ? 60 : size}
            style={{
              color: '#fff',
              fontSize: size == 'small' ? 11 : undefined,
            }}
          />
        </Tooltip>
        {type == 'full' && (
          <Space.Compact direction="vertical">
            <Space size={0} direction="vertical">
              <Text>{contact.instagramName}</Text>
              <Text type="secondary" italic>
                @{contact.instagramUsername}
              </Text>
            </Space>
          </Space.Compact>
        )}
      </Space>
    </Link>
  )
}

export type ContactAvatarType = { Avatar: typeof ContactAvatar }
